import { PriceHistoricEntity } from '../../Entities/index.exports';
import { BasePriceHistoricFrontEndApiCalls } from '../index.exports';

//TODO: eliminar esta clase, no se usa
export class PriceHistoricApi extends BasePriceHistoricFrontEndApiCalls {
    protected static _Entity = PriceHistoricEntity;

    // #region api

    // #endregion api
}
